import { t } from '@lingui/macro'
import { OrganisationRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

export const availableRoles = [
  {
    value: OrganisationRoleEnum.STUDENT,
    label: t`User`
  },
  {
    value: OrganisationRoleEnum.ADMIN,
    label: t`Administrator`
  }
]

export const isOrgEmailEnabled = (organisation) =>
  organisation.email_comments || organisation.email_content
